/*=========================================================================================
	File Name: moduleCalendarActions.js
	Description: Calendar Module Actions
	----------------------------------------------------------------------------------------
	Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
	Author: Pixinvent
	Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


import userJson from "../../../public/user.json";
import axios from "axios";
import router from '../../router'
import store from "../store";

export default {
	deleteUser({ commit }, item) {
		var sistemAddress = userJson.userService;
		const token = localStorage.getItem("fullFilmentTokenId")
		if (!token) { store.dispatch("auth/logout"); router.push("/login"); } 
		return new Promise((resolve, reject) => {
			axios
				.delete(sistemAddress + "api/uzumservice/User/delete/user/" + item, {
					headers: {
						Authorization: `Bearer ${token}`
					}
				})
				.then(response => {
					commit("DELETE_ITEM_USER", item)
					resolve(response);
				})
				.catch(err => {
					if (err.response.status == 401) {
						router.push("/login")
					}
					resolve(err.response);
				});
		});
	},
	addUser({ commit }, item) {
		var sistemAddress = userJson.userService;
		const token = localStorage.getItem("fullFilmentTokenId")
		if (!token) { store.dispatch("auth/logout"); router.push("/login"); }
		return new Promise((resolve, reject) => {
			axios
				.post(sistemAddress + "api/uzumservice/User/add/user", item, {
					headers: {
						Authorization: `Bearer ${token}`,
						token: token
					}
				})
				.then(response => { 
					commit("ADD_ITEM_USER", item)
					resolve(response);
				})
				.catch(err => {
					if (err.response.status == 401) {
						router.push("/login")
					}
					resolve(err.response);
				});
		});
	},
	listUser({ commit }, item) {
		var sistemAddress = userJson.userService;
		const token = localStorage.getItem("fullFilmentTokenId")

		if (token === null || token == "null") { }
		else
			return new Promise((resolve, reject) => {
				axios.get(sistemAddress + "api/uzumservice/User/list/user", {
					headers: {
						Authorization: `Bearer ${token}`,
						token: token
					}
				}).then(response => {
					if (response.status == 200) {
						item = JSON.parse(response.data.json);
						commit("USER_LIST", item);
						resolve(response.data);
					} else if (response.status == 401) {
						router.push("/login")
					}
				}).catch(err => {
					if (err.response.status == 401) {
						router.push("/login")
					}
					resolve(err.response);
				});;
			});
	},
}
